module.exports = __webpack_public_path__ + "img/icon_help.8f68a6e5.svg";